// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TripSummary } from './TripSummary';
import {
    TripSummaryFromJSON,
    TripSummaryFromJSONTyped,
    TripSummaryToJSON,
    TripSummaryToJSONTyped,
} from './TripSummary';
import type { ArchiveConnectionReliability } from './ArchiveConnectionReliability';
import {
    ArchiveConnectionReliabilityFromJSON,
    ArchiveConnectionReliabilityFromJSONTyped,
    ArchiveConnectionReliabilityToJSON,
    ArchiveConnectionReliabilityToJSONTyped,
} from './ArchiveConnectionReliability';
import type { OperatingPeriod } from './OperatingPeriod';
import {
    OperatingPeriodFromJSON,
    OperatingPeriodFromJSONTyped,
    OperatingPeriodToJSON,
    OperatingPeriodToJSONTyped,
} from './OperatingPeriod';
import type { TripStatus } from './TripStatus';
import {
    TripStatusFromJSON,
    TripStatusFromJSONTyped,
    TripStatusToJSON,
    TripStatusToJSONTyped,
} from './TripStatus';
import type { EcoBalance } from './EcoBalance';
import {
    EcoBalanceFromJSON,
    EcoBalanceFromJSONTyped,
    EcoBalanceToJSON,
    EcoBalanceToJSONTyped,
} from './EcoBalance';
import type { Leg } from './Leg';
import {
    LegFromJSON,
    LegFromJSONTyped,
    LegToJSON,
    LegToJSONTyped,
} from './Leg';

/**
 * A customer journey describing the movement of a passenger from one Place of any sort to another. A Trip may consist of one or more consecutive Leg's having some common characteristics.
 * @export
 * @interface Trip
 */
export interface Trip {
    /**
     * TripContext to reconstruct this Trip.
     * @type {string}
     * @memberof Trip
     */
    id: string;
    /**
     * 
     * @type {Array<Leg>}
     * @memberof Trip
     */
    legs: Array<Leg>;
    /**
     * 
     * @type {TripStatus}
     * @memberof Trip
     */
    status: TripStatus;
    /**
     * Relates to `TripMobilityFilter::walkSpeed`, if transfers below 100% were enforced, such Trip's are marked as `fastTransfer` by means passenger needs to hurry to get next vehicle because transfer time is lower than recommended at a StopPlace.
     * @type {boolean}
     * @memberof Trip
     */
    fastTransfer: boolean;
    /**
     * Number of interchanges (de:Umstiege) [greater or equal 0].
     * @type {number}
     * @memberof Trip
     */
    transfers: number;
    /**
     * The [duration](https://www.w3.org/TR/xmlschema11-2/#duration) of the whole `Trip`. The value may be null, if `Trip` is not rideable (for e.g. cancelled).
     * @type {string}
     * @memberof Trip
     */
    duration?: string;
    /**
     * Checksum of the trip to filter same results on client side after scroll requests. Relates to `TripResponse::paginationCursor`.
     * @type {string}
     * @memberof Trip
     */
    pagingChecksum?: string;
    /**
     * A hint/explanation is given if Trip was not found by a direct (first) search. In such a case origin/destination might not match exactly to request parameters.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof Trip
     */
    searchHint?: string;
    /**
     * Operating days of 'same journey' within planned yearly operating-period though multiple entries are possible (for e.g. `Operator` change or different daysRegular/daysIrregular). Given for `Trip's` containing `PTRideLeg's`. Set includeOperatingDays for concrete `OperatingPeriod::operatingDays` if needed.
     * @type {Array<OperatingPeriod>}
     * @memberof Trip
     */
    operatingPeriods: Array<OperatingPeriod>;
    /**
     * 
     * @type {EcoBalance}
     * @memberof Trip
     * @deprecated
     */
    ecoBalance?: EcoBalance;
    /**
     * 
     * @type {ArchiveConnectionReliability}
     * @memberof Trip
     */
    archiveConnectionReliability?: ArchiveConnectionReliability;
    /**
     * 
     * @type {TripSummary}
     * @memberof Trip
     */
    summary?: TripSummary;
}

/**
 * Check if a given object implements the Trip interface.
 */
export function instanceOfTrip(value: object): value is Trip {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('legs' in value) || value['legs'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('fastTransfer' in value) || value['fastTransfer'] === undefined) return false;
    if (!('transfers' in value) || value['transfers'] === undefined) return false;
    if (!('operatingPeriods' in value) || value['operatingPeriods'] === undefined) return false;
    return true;
}

export function TripFromJSON(json: any): Trip {
    return TripFromJSONTyped(json, false);
}

export function TripFromJSONTyped(json: any, ignoreDiscriminator: boolean): Trip {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'legs': ((json['legs'] as Array<any>).map(LegFromJSON)),
        'status': TripStatusFromJSON(json['status']),
        'fastTransfer': json['fastTransfer'],
        'transfers': json['transfers'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'pagingChecksum': json['pagingChecksum'] == null ? undefined : json['pagingChecksum'],
        'searchHint': json['searchHint'] == null ? undefined : json['searchHint'],
        'operatingPeriods': ((json['operatingPeriods'] as Array<any>).map(OperatingPeriodFromJSON)),
        'ecoBalance': json['ecoBalance'] == null ? undefined : EcoBalanceFromJSON(json['ecoBalance']),
        'archiveConnectionReliability': json['archiveConnectionReliability'] == null ? undefined : ArchiveConnectionReliabilityFromJSON(json['archiveConnectionReliability']),
        'summary': json['summary'] == null ? undefined : TripSummaryFromJSON(json['summary']),
    };
}

  export function TripToJSON(json: any): Trip {
      return TripToJSONTyped(json, false);
  }

  export function TripToJSONTyped(value?: Trip | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'legs': ((value['legs'] as Array<any>).map(LegToJSON)),
        'status': TripStatusToJSON(value['status']),
        'fastTransfer': value['fastTransfer'],
        'transfers': value['transfers'],
        'duration': value['duration'],
        'pagingChecksum': value['pagingChecksum'],
        'searchHint': value['searchHint'],
        'operatingPeriods': ((value['operatingPeriods'] as Array<any>).map(OperatingPeriodToJSON)),
        'ecoBalance': EcoBalanceToJSON(value['ecoBalance']),
        'archiveConnectionReliability': ArchiveConnectionReliabilityToJSON(value['archiveConnectionReliability']),
        'summary': TripSummaryToJSON(value['summary']),
    };
}

